import React, { useState } from 'react';
import { CookiesProvider } from 'react-cookie';

import Jumbotron from './components/Jumbotron/Jumbotron';
import Table from './components/Table';

import InvoiceDocument from './components/PdfGenerator/InvoiceDocument';
import InvoiceContainer from './components/PdfGenerator/InvoiceContainer';

import { connect } from 'react-redux';
import { RowFields, MetaFields, OfficeAddresses } from './Constants';
import { getInterestAccumulated } from './selectors/index';

import SafariHelperModal from './components/SafariHelperModal';

import './index.css';

const App = ({ docRowData, docMetaData }) => {

  const [showInvoice, setShowInvoice] = useState(false);
  const [showMetaFields, setShowMetaFields] = useState(false);
  
  const toggleShowInvoice = () => setShowInvoice(!showInvoice);
  const toggleShowMetaFields = () => setShowMetaFields(!showMetaFields);

  const fileName = docMetaData.fileName
  const invoice = <InvoiceDocument 
      rowData={docRowData} 
      metaData={docMetaData}/>

  return (
    <CookiesProvider>
      <div className="app">

        {/* If Safari, display tip for using tab to focus */}
        { !!window.safari ? <SafariHelperModal/> : null}

        <Jumbotron 
          previewButtonText={showInvoice ? "Close Preview" : "Preview Invoice"}
          invoicePreviewClickHandler={toggleShowInvoice}
          metaFieldsClickHandler={toggleShowMetaFields}
          doc={invoice}
          fileName={fileName}/>

        <div className="main-flex-container">
          <Table/>
          <InvoiceContainer 
            show={showInvoice} 
            doc={invoice}/>
        </div>
      </div>
    </CookiesProvider>
  )
}

const mapRowDataForInvoice = row => {

    const convertIsoFormatToNormal = dateStr => {
        const date = new Date(`${dateStr}`);
        const year = date.getUTCFullYear();
        const day = date.getUTCDate(); // zero-indexed
        const month = date.getUTCMonth()+1; // zero-indexed

        return `${month}/${day}/${year}`;
    }

    let [, value] = getInterestAccumulated(row);

    // TODO: check for other invalid fields that the accumulatedInterest doesnt account for
    if (!(typeof value === "number")) {
        return {
            description: "There are invalid fields in the form.",
            value: 0
        }
    }

    const startDateOfService = row[RowFields.StartDatesOfService.id].value;
    const endDateOfService = row[RowFields.EndDatesOfService.id].value;
    const amountPaid = row[RowFields.AmountPaid.id].value;
    const datePaymentReceived = row[RowFields.DatePaid.id].value;
    const dateBillSent = row[RowFields.DateBillSent.id].value;

    const isPartial = !!row.hasPartials || (row.rowType === "partial");
    const partialString = isPartial ? " partial" : "";

    const d1 = convertIsoFormatToNormal(startDateOfService);
    const d2 = convertIsoFormatToNormal(endDateOfService);
    const d3 = convertIsoFormatToNormal(datePaymentReceived);
    const d4 = convertIsoFormatToNormal(dateBillSent);

    //const description = `Interest only for dates of service ${d1} – ${d2}, overdue ${partialString}
    //    payment of $${amountPaid} received on ${d3}. ` +
    //    `Bill sent ${d4}`;
    const description = `Interest only for dates of service ${d1} – ${d2}, overdue${partialString} payment of $${amountPaid} received on ${d3}. Bill sent ${d4}.`;
    
    return { value, description }
}

const transformMetaDataObj = metaDataObj => {

    let fromAddress = {
        name: "INVALID OFFICE ADDRESS",
        line1: "INVALID OFFICE ADDRESS",
        line2: "INVALID OFFICE ADDRESS"
    };

    const patientName = metaDataObj[MetaFields.PatientName.id] || "INVALID PATIENT NAME";

    const officeAddressIdx = metaDataObj[MetaFields.OfficeAddress.id];
    if (officeAddressIdx) {
        const officeName = OfficeAddresses[officeAddressIdx].name;
        const line1 = OfficeAddresses[officeAddressIdx].line1;
        const line2 = OfficeAddresses[officeAddressIdx].line2;
        fromAddress = {
            name: officeName,
            line1,
            line2
        }
    }

    let fileName;
    if (!!officeAddressIdx && !!patientName && !patientName.includes("INVALID")) {
        const officeName = OfficeAddresses[officeAddressIdx].name
        const officeInitials = officeName && officeName.split(' ').reduce( (agg, curr, idx) => (idx < 2) ? agg + curr[0].toUpperCase() : agg,'')
        fileName = `Interest Invoice ${patientName} ${officeInitials}`;
    } else {
        fileName = "INVALID PATIENT OR OFFICE";
    }

    const insuranceCompany = metaDataObj[MetaFields.InsuranceCompany.id] || "INVALID INSURANCE COMPANY";

    // Get fields to create "RE: " field
    const claimNumber = metaDataObj[MetaFields.ClaimNumber.id] || "INVALID CLAIM NUMBER"
    const re = patientName.startsWith("INVALID")
        ? "INVALID PATIENT NAME"
        : `Interest owed for delinquent payment on ${patientName}`

    // Get from fields
    return {
        fromAddress,
        toAddress: {
            attorneyName: "",
            insuranceCompany
        },
        claimArea: {
            re,
            claimNumber: claimNumber
        },
        fileName
    }
}

const mapStateToProps = state => {
    return {
        docRowData: state.interestForm.rowData.map(mapRowDataForInvoice),
        docMetaData: transformMetaDataObj(state.interestForm.metaData)
    }
}

export default connect(mapStateToProps)(App)